module.exports = __webpack_public_path__ + "img/190.fb0e3f49.jpg";